(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-meister-countdown]';
    const pad = (value) => String(value).padStart(2, '0');
    const updateCountdown = (countdown) => {
      const endTime = Date.parse(countdown.dataset.end);
      if (Number.isNaN(endTime)) { countdown.hidden = true; return; }
      const remaining = Math.max(0, endTime - Date.now());
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      countdown.querySelector('[data-days]').textContent = pad(days);
      countdown.querySelector('[data-hours]').textContent = pad(hours);
      countdown.querySelector('[data-minutes]').textContent = pad(minutes);
      countdown.querySelector('[data-seconds]').textContent = pad(seconds);
      if (remaining === 0 && countdown._meisterInterval) { window.clearInterval(countdown._meisterInterval); countdown._meisterInterval = null; }
    };
    const initCountdown = (countdown) => {
      if (countdown._meisterInterval) window.clearInterval(countdown._meisterInterval);
      updateCountdown(countdown);
      countdown._meisterInterval = window.setInterval(() => updateCountdown(countdown), 1000);
    };
    const initAll = (root = document) => root.querySelectorAll(selector).forEach(initCountdown);
    const cleanupAll = (root) => root.querySelectorAll(selector).forEach((countdown) => {
      if (countdown._meisterInterval) { window.clearInterval(countdown._meisterInterval); countdown._meisterInterval = null; }
    });
    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => cleanupAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, instance) => {
        this.headerBounds = entries[0].intersectionRect;
        instance.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-cookie-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupCookieBanner = (scope = document) => {
      const banner = scope.querySelector?.('[data-mc-cookie-banner]') || document.querySelector('[data-mc-cookie-banner]');
      if (!banner || banner.dataset.mcCookieReady === 'true') return;
      banner.dataset.mcCookieReady = 'true';

      const root = document.documentElement;
      const acceptButton = banner.querySelector('[data-mc-cookie-accept]');
      const declineButton = banner.querySelector('[data-mc-cookie-decline]');
      const manageButton = banner.querySelector('[data-mc-cookie-manage]');
      let decisionLocked = false;
      let settleTimer;

      root.classList.add('mc-cookie-custom-ready');

      const getNativeBanner = () => document.querySelector('#shopify-pc__banner');
      const getPrivacy = () => window.Shopify && window.Shopify.customerPrivacy;

      const getCurrentConsent = () => {
        const privacy = getPrivacy();
        if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return null;
        try {
          return privacy.currentVisitorConsent();
        } catch (error) {
          return null;
        }
      };

      const consentIsResolved = (consent) => {
        if (!consent) return false;
        return ['analytics', 'marketing', 'preferences'].every((key) => consent[key] === 'yes' || consent[key] === 'no');
      };

      const nativeWantsBanner = () => {
        const nativeBanner = getNativeBanner();
        if (!nativeBanner) return false;
        if (nativeBanner.hidden || nativeBanner.getAttribute('aria-hidden') === 'true') return false;
        return true;
      };

      const shouldShow = () => {
        if (decisionLocked) return false;

        const consent = getCurrentConsent();
        if (consentIsResolved(consent)) return false;

        const privacy = getPrivacy();
        if (privacy && typeof privacy.shouldShowBanner === 'function') {
          try {
            return Boolean(privacy.shouldShowBanner());
          } catch (error) {
            // Fall back to the native Shopify banner state.
          }
        }

        return nativeWantsBanner();
      };

      const show = () => {
        if (decisionLocked) return;
        root.classList.add('mc-cookie-custom-active');
        banner.hidden = false;
      };

      const hide = () => {
        banner.hidden = true;
        root.classList.remove('mc-cookie-custom-active');
      };

      const findNativeAction = (kind) => {
        const nativeBanner = getNativeBanner();
        if (!nativeBanner) return null;

        const selectors = {
          accept: '#shopify-pc__banner__btn-accept, .shopify-pc__banner__btn-accept',
          decline: '#shopify-pc__banner__btn-decline, .shopify-pc__banner__btn-decline',
          manage: '#shopify-pc__banner__btn-manage-prefs, .shopify-pc__banner__btn-manage-prefs'
        };

        const exact = nativeBanner.querySelector(selectors[kind]);
        if (exact) return exact;

        const patterns = {
          accept: /accept|permite|allow/i,
          decline: /refuz|declin|reject|respinge/i,
          manage: /preferin|preference|manage/i
        };

        return Array.from(nativeBanner.querySelectorAll('button, a')).find((node) => patterns[kind].test(node.textContent || '')) || null;
      };

      const verifyConsent = () => {
        const resolved = consentIsResolved(getCurrentConsent());
        if (resolved) {
          decisionLocked = true;
          hide();
        }
        return resolved;
      };

      const setConsent = (accepted) => {
        decisionLocked = true;
        hide();
        window.clearTimeout(settleTimer);

        const privacy = getPrivacy();
        const payload = {
          analytics: accepted,
          marketing: accepted,
          preferences: accepted
        };

        let callbackRan = false;

        if (privacy && typeof privacy.setTrackingConsent === 'function') {
          try {
            privacy.setTrackingConsent(payload, () => {
              callbackRan = true;
              verifyConsent();
              hide();
            });
          } catch (error) {
            // Native Shopify action below is the fallback.
          }
        }

        const nativeAction = findNativeAction(accepted ? 'accept' : 'decline');
        if (nativeAction) {
          window.setTimeout(() => {
            if (!callbackRan && !verifyConsent()) nativeAction.click();
          }, 220);
        }

        settleTimer = window.setTimeout(() => {
          if (!verifyConsent()) {
            const fallbackAction = findNativeAction(accepted ? 'accept' : 'decline');
            if (fallbackAction) fallbackAction.click();

            if (privacy && typeof privacy.setTrackingConsent === 'function') {
              try {
                privacy.setTrackingConsent(payload, () => {
                  verifyConsent();
                  hide();
                });
              } catch (error) {
                // Keep the custom banner closed for this page after the user's explicit choice.
              }
            }
          }

          hide();
        }, 900);
      };

      const openPreferences = () => {
        const nativeManage = findNativeAction('manage');
        if (nativeManage) {
          nativeManage.click();
          return;
        }

        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
          window.privacyBanner.showPreferences();
        }
      };

      acceptButton?.addEventListener('click', () => setConsent(true));
      declineButton?.addEventListener('click', () => setConsent(false));
      manageButton?.addEventListener('click', openPreferences);

      document.addEventListener('visitorConsentCollected', () => {
        decisionLocked = true;
        hide();
      });

      const sync = () => {
        if (shouldShow()) show();
        else hide();
      };

      if (window.Shopify && !getPrivacy() && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          () => sync()
        );
      }

      sync();
      window.setTimeout(sync, 180);
      window.setTimeout(sync, 700);
      window.setTimeout(sync, 1600);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setupCookieBanner(), { once: true });
    } else {
      setupCookieBanner();
    }

    document.addEventListener('shopify:section:load', (event) => setupCookieBanner(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-floating-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupFloatingOffer = (scope = document) => {
      const widgets = [];
      if (scope.matches?.('[data-mc-offer-widget]')) widgets.push(scope);
      scope.querySelectorAll?.('[data-mc-offer-widget]').forEach((widget) => widgets.push(widget));

      widgets.forEach((widget) => {
        if (widget.dataset.mcOfferReady === 'true') return;
        widget.dataset.mcOfferReady = 'true';

        const trigger = widget.querySelector('[data-mc-offer-trigger]');
        const panel = widget.querySelector('[data-mc-offer-panel]');
        const closeButton = widget.querySelector('[data-mc-offer-close]');
        if (!trigger || !panel || !closeButton) return;

        const openPanel = () => {
          if (widget.classList.contains('is-cart-hidden') || widget.classList.contains('is-cookie-hidden')) return;
          widget.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.setAttribute('aria-hidden', 'false');
          window.setTimeout(() => panel.querySelector('input:not([type="hidden"]), textarea, button')?.focus(), 80);
        };

        const closePanel = (returnFocus = false) => {
          widget.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          panel.setAttribute('aria-hidden', 'true');
          if (returnFocus) trigger.focus();
        };

        trigger.addEventListener('click', () => {
          if (widget.classList.contains('is-open')) closePanel(true);
          else openPanel();
        });
        closeButton.addEventListener('click', () => closePanel(true));

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && widget.classList.contains('is-open')) closePanel(true);
        });

        document.addEventListener('pointerdown', (event) => {
          if (widget.classList.contains('is-open') && !widget.contains(event.target)) closePanel(false);
        });

        const root = document.documentElement;
        const cookieBanner = document.querySelector('[data-mc-cookie-banner]');
        let cookieDecisionMade = false;

        const getPrivacy = () => window.Shopify && window.Shopify.customerPrivacy;
        const getCurrentConsent = () => {
          const privacy = getPrivacy();
          if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return null;
          try {
            return privacy.currentVisitorConsent();
          } catch (error) {
            return null;
          }
        };

        const consentIsResolved = (consent) => {
          if (!consent) return false;
          return ['analytics', 'marketing', 'preferences'].every((key) => consent[key] === 'yes' || consent[key] === 'no');
        };

        const syncCookieGate = () => {
          const bannerVisible = Boolean(cookieBanner && !cookieBanner.hidden) || root.classList.contains('mc-cookie-custom-active');
          let gateOpen = cookieDecisionMade && !bannerVisible;

          if (!gateOpen && !bannerVisible) {
            const consent = getCurrentConsent();
            if (consentIsResolved(consent)) {
              gateOpen = true;
            } else {
              const privacy = getPrivacy();
              if (privacy && typeof privacy.shouldShowBanner === 'function') {
                try {
                  gateOpen = !privacy.shouldShowBanner();
                } catch (error) {
                  gateOpen = false;
                }
              }
            }
          }

          widget.classList.toggle('is-cookie-hidden', !gateOpen);
          if (!gateOpen) closePanel(false);
        };

        const releaseCookieGate = () => {
          cookieDecisionMade = true;
          window.setTimeout(syncCookieGate, 0);
          window.setTimeout(syncCookieGate, 260);
        };

        const cookieClickHandler = (event) => {
          if (event.target.closest('[data-mc-cookie-accept], [data-mc-cookie-decline]')) releaseCookieGate();
        };

        const consentHandler = () => releaseCookieGate();
        document.addEventListener('click', cookieClickHandler);
        document.addEventListener('visitorConsentCollected', consentHandler);

        const cookieObserver = new MutationObserver(syncCookieGate);
        cookieObserver.observe(root, { attributes: true, attributeFilter: ['class'] });
        if (cookieBanner) cookieObserver.observe(cookieBanner, { attributes: true, attributeFilter: ['hidden'] });
        widget.mcOfferCookieObserver = cookieObserver;
        widget.mcOfferCookieClickHandler = cookieClickHandler;
        widget.mcOfferConsentHandler = consentHandler;

        const drawer = document.querySelector('cart-drawer');
        const syncCart = () => {
          const cartOpen = Boolean(drawer?.classList.contains('active'));
          widget.classList.toggle('is-cart-hidden', cartOpen);
          if (cartOpen) closePanel(false);
        };

        if (drawer) {
          const cartObserver = new MutationObserver(syncCart);
          cartObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
          widget.mcOfferCartObserver = cartObserver;
        }

        syncCookieGate();
        syncCart();
        window.setTimeout(syncCookieGate, 200);
        window.setTimeout(syncCookieGate, 800);
        window.setTimeout(syncCookieGate, 1700);

        if (window.Shopify && !getPrivacy() && typeof window.Shopify.loadFeatures === 'function') {
          try {
            window.Shopify.loadFeatures(
              [{ name: 'consent-tracking-api', version: '0.1' }],
              () => syncCookieGate()
            );
          } catch (error) {
            // Timed syncs above keep the CTA safely hidden until consent state is known.
          }
        }

        if (panel.querySelector('[data-mc-offer-result]')) {
          window.setTimeout(() => {
            syncCookieGate();
            if (!widget.classList.contains('is-cookie-hidden')) openPanel();
          }, 100);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setupFloatingOffer(), { once: true });
    } else {
      setupFloatingOffer();
    }

    document.addEventListener('shopify:section:load', (event) => setupFloatingOffer(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll?.('[data-mc-offer-widget]').forEach((widget) => {
        widget.mcOfferCartObserver?.disconnect();
        widget.mcOfferCookieObserver?.disconnect();
        if (widget.mcOfferCookieClickHandler) document.removeEventListener('click', widget.mcOfferCookieClickHandler);
        if (widget.mcOfferConsentHandler) document.removeEventListener('visitorConsentCollected', widget.mcOfferConsentHandler);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-home-videos"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initHomeVideoSection = (scope=document) => {
    scope.querySelectorAll('[data-mc-home-video-section]').forEach((section) => {
      if(section.dataset.mcVideoReady==='true')return;
      section.dataset.mcVideoReady='true';

      const modal=section.querySelector('[data-mc-video-modal]');
      const dialog=modal?.querySelector('.mc-product-video-modal__dialog');
      const stage=modal?.querySelector('[data-mc-video-stage]');
      const playButton=modal?.querySelector('[data-mc-video-play]');
      const soundButton=modal?.querySelector('[data-mc-video-sound]');
      if(!modal||!dialog||!stage||!playButton||!soundButton)return;

      let activeVideo=null;
      let lastTrigger=null;

      const syncState=()=>{
        if(!activeVideo)return;
        const isPlaying=!activeVideo.paused;
        const hasSound=!activeVideo.muted;
        dialog.classList.toggle('is-playing',isPlaying);
        dialog.classList.toggle('has-sound',hasSound);
        playButton.setAttribute('aria-label',isPlaying?'Pauză':'Redă');
        soundButton.setAttribute('aria-label',hasSound?'Dezactivează sunetul':'Activează sunetul');
      };

      const closeModal=()=>{
        if(activeVideo){
          activeVideo.pause();
          activeVideo.currentTime=0;
        }
        stage.replaceChildren();
        activeVideo=null;
        modal.hidden=true;
        dialog.classList.remove('is-playing','has-sound');
        document.body.classList.remove('mc-video-modal-open');
        lastTrigger?.focus();
      };

      section.querySelectorAll('[data-mc-video-open]').forEach((trigger)=>trigger.addEventListener('click',()=>{
        const template=trigger.closest('.mc-product-video-card')?.querySelector('[data-mc-video-template]');
        if(!template)return;

        stage.replaceChildren(template.content.cloneNode(true));
        activeVideo=stage.querySelector('video');
        if(!activeVideo)return;

        activeVideo.muted=false;
        activeVideo.volume=1;
        activeVideo.addEventListener('play',syncState);
        activeVideo.addEventListener('pause',syncState);
        activeVideo.addEventListener('volumechange',syncState);
        activeVideo.addEventListener('click',()=>{
          if(activeVideo.paused){
            const attempt=activeVideo.play();
            attempt?.catch?.(()=>syncState());
          }else{
            activeVideo.pause();
          }
        });

        lastTrigger=trigger;
        modal.hidden=false;
        document.body.classList.add('mc-video-modal-open');
        syncState();

        const attempt=activeVideo.play();
        attempt?.catch?.(()=>syncState());
        modal.querySelector('[data-mc-video-close]')?.focus();
      }));

      modal.querySelectorAll('[data-mc-video-close]').forEach((button)=>button.addEventListener('click',closeModal));

      playButton.addEventListener('click',()=>{
        if(!activeVideo)return;
        if(activeVideo.paused){
          const attempt=activeVideo.play();
          attempt?.catch?.(()=>syncState());
        }else{
          activeVideo.pause();
        }
      });

      soundButton.addEventListener('click',()=>{
        if(!activeVideo)return;
        activeVideo.muted=!activeVideo.muted;
        syncState();
      });

      document.addEventListener('keydown',(event)=>{
        if(event.key==='Escape'&&!modal.hidden)closeModal();
      });
    });
  };

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',()=>initHomeVideoSection(),{once:true});
  }else{
    initHomeVideoSection();
  }

  document.addEventListener('shopify:section:load',(event)=>initHomeVideoSection(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-offer-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.mcPresentationOfferCardsReady) return;
    window.mcPresentationOfferCardsReady = true;
    const pendingKey = 'mcPendingOfferPresentation';

    const openOfferForm = (detail) => {
      if (!detail || !detail.title) return;
      const widget = document.querySelector('[data-mc-offer-widget]');
      if (!widget) { window[pendingKey] = detail; return; }

      const textarea = widget.querySelector('textarea[name="contact[body]"]');
      const lines = [`Doresc o ofertă pentru: ${detail.title}`];
      if (detail.reference) lines.push(`Referință: ${detail.reference}`);
      lines.push('', `Pagina: ${window.location.href}`);

      if (textarea) {
        textarea.value = lines.join('\n');
        textarea.dispatchEvent(new Event('input', { bubbles: true }));
        textarea.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (widget.classList.contains('is-cookie-hidden') || widget.classList.contains('is-cart-hidden')) { window[pendingKey] = detail; return; }
      window[pendingKey] = null;
      if (!widget.classList.contains('is-open')) widget.querySelector('[data-mc-offer-trigger]')?.click();
      window.setTimeout(() => textarea?.focus(), 120);
    };

    const replayPending = () => [180, 500, 1000, 1800].forEach((delay) => window.setTimeout(() => { if (window[pendingKey]) openOfferForm(window[pendingKey]); }, delay));

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-mc-request-offer]');
      if (!button) return;
      event.preventDefault();
      openOfferForm({ title: button.dataset.offerTitle || '', reference: button.dataset.offerReference || '' });
    });

    document.addEventListener('visitorConsentCollected', replayPending);
    document.addEventListener('click', (event) => { if (event.target.closest('[data-mc-cookie-accept], [data-mc-cookie-decline]')) replayPending(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-product-shell"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initShell = (scope = document) => {
    scope.querySelectorAll('[data-mc-product-shell]').forEach((shell) => {
      if (shell.dataset.mcReady === 'true') return;
      shell.dataset.mcReady = 'true';
      const template = shell.querySelector('[data-mc-product-review-template]');
      const productInfo = document.querySelector('product-info[id^="MainProduct-"]');
      const mediaWrapper = productInfo?.querySelector('.product__media-wrapper');
      const infoContainer = productInfo?.querySelector('.product__info-container');
      const productTitle = infoContainer?.querySelector('.product__title');
      if (!template || !productInfo || !mediaWrapper || productInfo.querySelector('[data-mc-product-reviewbar]')) return;
      const reviewBar = template.content.firstElementChild.cloneNode(true);
      const judgeBadge = reviewBar.querySelector('.jdgm-prev-badge');
      const standardRating = Number(reviewBar.dataset.rating || 0);
      const standardCount = Number(reviewBar.dataset.count || 0);
      const judgeRating = Number(judgeBadge?.dataset.averageRating || 0);
      const judgeCount = Number(judgeBadge?.dataset.numberOfReviews || 0);
      const rating = judgeCount > 0 ? judgeRating : standardRating;
      const count = judgeCount > 0 ? judgeCount : standardCount;
      reviewBar.querySelector('.mc-product-reviewbar__stars-fill')?.style.setProperty('--mc-rating-width', `${Math.max(0, Math.min(100, rating * 20))}%`);
      const countNode = reviewBar.querySelector('[data-mc-review-count]');
      const labelNode = reviewBar.querySelector('[data-mc-review-label]');
      if (countNode) countNode.textContent = String(count);
      if (labelNode) labelNode.textContent = count === 1 ? 'recenzie' : 'recenzii';
      reviewBar.querySelector('[data-mc-scroll-reviews]')?.addEventListener('click', () => {
        const reviewTarget = document.querySelector('#judgeme_product_reviews') || document.querySelector('.jdgm-rev-widg') || document.querySelector('[data-mc-product-faq]');
        reviewTarget?.scrollIntoView({ behavior:'smooth', block:'start' });
      });

      const desktopQuery = window.matchMedia('(min-width: 990px)');
      const placeReviewBar = () => {
        if (desktopQuery.matches && productTitle) productTitle.insertAdjacentElement('afterend', reviewBar);
        else mediaWrapper.appendChild(reviewBar);
      };
      placeReviewBar();
      if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', placeReviewBar);
      else if (desktopQuery.addListener) desktopQuery.addListener(placeReviewBar);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initShell(), { once:true });
  else initShell();
  document.addEventListener('shopify:section:load', (event) => initShell(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-product-videos"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initVideoSection = (scope=document) => {
    scope.querySelectorAll('[data-mc-video-section]').forEach((section) => {
      if(section.dataset.mcVideoReady==='true')return;section.dataset.mcVideoReady='true';
      const modal=section.querySelector('[data-mc-video-modal]'),dialog=modal?.querySelector('.mc-product-video-modal__dialog'),stage=modal?.querySelector('[data-mc-video-stage]'),playButton=modal?.querySelector('[data-mc-video-play]'),soundButton=modal?.querySelector('[data-mc-video-sound]');
      if(!modal||!dialog||!stage||!playButton||!soundButton)return;let activeVideo=null,lastTrigger=null;
      const syncState=()=>{if(!activeVideo)return;const isPlaying=!activeVideo.paused;const hasSound=!activeVideo.muted;dialog.classList.toggle('is-playing',isPlaying);dialog.classList.toggle('has-sound',hasSound);playButton.setAttribute('aria-label',isPlaying?'Pauză':'Redă');soundButton.setAttribute('aria-label',hasSound?'Dezactivează sunetul':'Activează sunetul')};
      const closeModal=()=>{if(activeVideo){activeVideo.pause();activeVideo.currentTime=0}stage.replaceChildren();activeVideo=null;modal.hidden=true;dialog.classList.remove('is-playing','has-sound');document.body.classList.remove('mc-video-modal-open');lastTrigger?.focus()};
      section.querySelectorAll('[data-mc-video-open]').forEach((trigger)=>trigger.addEventListener('click',()=>{const template=trigger.closest('.mc-product-video-card')?.querySelector('[data-mc-video-template]');if(!template)return;stage.replaceChildren(template.content.cloneNode(true));activeVideo=stage.querySelector('video');if(!activeVideo)return;activeVideo.muted=false;activeVideo.volume=1;activeVideo.addEventListener('play',syncState);activeVideo.addEventListener('pause',syncState);activeVideo.addEventListener('volumechange',syncState);activeVideo.addEventListener('click',()=>{if(activeVideo.paused){const attempt=activeVideo.play();attempt?.catch?.(()=>syncState())}else activeVideo.pause()});lastTrigger=trigger;modal.hidden=false;document.body.classList.add('mc-video-modal-open');syncState();const attempt=activeVideo.play();attempt?.catch?.(()=>syncState());modal.querySelector('[data-mc-video-close]')?.focus()}));
      modal.querySelectorAll('[data-mc-video-close]').forEach((button)=>button.addEventListener('click',closeModal));
      playButton.addEventListener('click',()=>{if(!activeVideo)return;if(activeVideo.paused){const attempt=activeVideo.play();attempt?.catch?.(()=>syncState())}else activeVideo.pause()});
      soundButton.addEventListener('click',()=>{if(!activeVideo)return;activeVideo.muted=!activeVideo.muted;syncState()});
      document.addEventListener('keydown',(event)=>{if(event.key==='Escape'&&!modal.hidden)closeModal()});
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initVideoSection(),{once:true});else initVideoSection();document.addEventListener('shopify:section:load',(event)=>initVideoSection(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
